import React from "react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Check, X, Copy } from "lucide-react";
import ChangesSummary from "./ChangesSummary";

function StagedChangesToolbar({
    inserts, updates, deletes,
    onApply, onReset, onCopySQL,
    isApplying = false,
}) {
    const hasChanges = inserts.length > 0 || updates.size > 0 || deletes.size > 0;

    if (!hasChanges) return null;

    return (
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 border border-blue-200 rounded-lg">
            <ChangesSummary inserts={inserts} updates={updates} deletes={deletes} />
            <div className="flex items-center gap-2">
            
                <Button variant="outline" size="sm" onClick={onReset} className="gap-1">
                    <X className="w-3 h-3" />
                    Reset
                </Button>
                <Button size="sm" onClick={onApply} disabled={isApplying} className="gap-1">
                    <Check className="w-3 h-3" />
                    {isApplying ? "Applying..." : "Apply Changes"}
                </Button>
            </div>
        </div>
    );
}

export default React.memo(StagedChangesToolbar);
